<template>
  <section>

    <ModalVideoPlayer :video="selectedVideo"
                      :event-name="checkin.pica_service.event_name"
                      :event-date="checkin.pica_service.event_start_at"
                      :dt-photos-hd-available-formatted="checkin.pica_service.hd_available_from|formatDate"
                      :share-mode="checkin.pica_service.share_mode"/>

    <div class="video-gallery my-3"
         v-if="currentTab === BUYABLE ? checkin.has_buyable_videos : checkin.has_bought_videos">
      <div class="container">
        <div class="collage-photo__group-title">
          <div class="d-flex justify-content-between align-items-end">
            <h6 class="font-weight-medium">
              {{ $t('pages.checkins_detail.video_section_title') }}
            </h6>
            <div class="card d-none d-md-block bg-transparent border align-self-center"
                 style="border-color: #2b2a3e !important;font-size: 14px" v-if="currentTab === BUYABLE">
              <div class="card-body py-2 px-3 video-gallery-info-txt">
              <template v-if="videoOnlySale">
                {{ $t('pages.checkins_detail.video_only_section_selling_info') }}
            </template>
            <template v-else>
              {{ $t('pages.checkins_detail.video_section_selling_info') }}
            </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="video-list-wrap">
        <div class="container pb-5">
          <div class="d-flex flex-row flex-nowrap video-list" v-if="boughtVideos || buyableVideos">
            <collage-video-item v-for="(video, index) in (currentTab === BOUGHT ? boughtVideos : buyableVideos)"
                                :video="video"
                                :key="index" @select-video="selectVideo"
                                class="video-list__item" :class="[hasCustomVideo ? 'portrait' : 'landscape']"
                                />
            <!-- video custom -->
            <div v-if="showCustomVideoBox" class="video-list__item">
              <div class="card card-video-custom collage-video-item h-100"
                   :class="{'cursor-pointer':showCustomVideoModal}"
                   @click="showCustomVideoModal ? $bvModal.show('modal-custom-video'): null">
                <div class="card-img-caption h-100">
                  <div class="h-100 d-flex align-items-center justify-content-center">
                    <div class="text text--info" v-if="customVideoStatus === customVideoStatuses.AVAILABLE">
                      <h6>{{ $t('pages.custom_video.title_avail') }}</h6>
                      <template v-if="videoOnlySale">
                        <p>{{ $t('pages.custom_video.message_avail_only_video') }}</p>
                      </template>
                      <template v-else>
                        <p>{{ $t('pages.custom_video.message_avail') }}</p>
                      </template>

                    </div>
                    <div class="text" v-else-if="customVideoStatus === customVideoStatuses.WAITING">
                      <h6>{{ $t('pages.custom_video.title_waiting') }}</h6>
                      <p v-html="customVideoWaitingMessage"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class="container d-flex d-md-none justify-content-center py-3" v-if="currentTab === BUYABLE">
        <div class="card bg-transparent border align-self-center" style="border-color: #2b2a3e !important;">
          <div class="card-body py-2 px-3 video-gallery-info-txt">
            <template v-if="videoOnlySale">
                {{ $t('pages.checkins_detail.video_only_section_selling_info') }}
            </template>
            <template v-else>
              {{ $t('pages.checkins_detail.video_section_selling_info') }}
            </template>
          </div>
        </div>
      </div>

      <div class="container" v-if="videoOnlySale">
          <CtaPhotosUnavailableForEvent />
      </div>
    </div>

    <div class="container tab-content">
      <CheckinDetailPhotosListBuyable v-show="currentTab === BUYABLE"
                                      :checkin="checkin"
                                      :photos="buyablePhotos"
                                      :loading="loadingBuyable && loadingBuyableVideo"
                                      :price-for-all-photos="getPriceForAllPhotos"
                                      @photo-package-activated="$emit('photo-package-activated')"/>

      <CheckinDetailPhotosListBought v-show="currentTab === BOUGHT"
                                     :checkin="checkin"
                                     :photos="boughtPhotos"
                                     :loading="loadingBought && loadingBoughtVideo"
                                     :event-closed="checkin.pica_service.is_tagging_completed"
                                     :is-promo="isPromo"
                                     @media-removed="onMediaRemoved"/>

      <AllPhotos :checkin="checkin" v-if="showAllEventPhotos"/>
    </div>


  </section>
</template>


<script>
import CheckinDetailPhotosListBuyable from "@/components/CheckinDetailPhotosListBuyable"
import CheckinDetailPhotosListBought from "@/components/CheckinDetailPhotosListBought"
import EventService from "@/services/Event"
import ModalVideoPlayer from "@/components/ModalVideoPlayer"
import CollageVideoItem from "@/components/CollageVideoItem.vue";
import AllPhotos from "@/domain/media/allPhotos/AllPhotos.vue";
import CtaPhotosUnavailableForEvent from "@/domain/checkinDetail/cta/CtaPhotosUnavailableForEvent.vue";

const BUYABLE = 'Buyable'
const BOUGHT = 'Bought'

const customVideoStatuses = {
  AVAILABLE: 'avl',
  WAITING: 'waiting',
  DELIVERED: 'delivered'
}

export default {
  components: {
    CtaPhotosUnavailableForEvent,
    AllPhotos,
    CollageVideoItem,
    CheckinDetailPhotosListBuyable,
    CheckinDetailPhotosListBought,
    ModalVideoPlayer
  },

  props: {
    checkin: {
      type: Object,
      required: true
    },
    currentTab: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      BUYABLE: BUYABLE,
      BOUGHT: BOUGHT,
      buyablePhotos: [],
      boughtPhotos: [],
      buyableVideos: [],
      boughtVideos: [],
      selectedVideo: null,
      loadingBought: true,
      loadingBuyable: true,
      loadingBoughtVideo: true,
      loadingBuyableVideo: true,
    }
  },

  computed: {
    showAllEventPhotos() {
      return this.currentTab === BOUGHT && this.checkin.show_all_event_photos
    },
    showCustomVideoBox() {
      return this.hasCustomVideo && this.customVideoStatus !== customVideoStatuses.DELIVERED
    },
    showCustomVideoModal() {
      return this.hasCustomVideo && this.customVideoStatus === customVideoStatuses.AVAILABLE
    },
    customVideoStatuses() {
      return customVideoStatuses
    },
    customVideoStatus() {
      return this.checkin.price_list && this.checkin.price_list.custom_video_status
    },
    customVideoAvlFrom() {
      return this.checkin.price_list && this.checkin.price_list.custom_video_avl_from
    },
    videoOnlySale() {
      return this.checkin.price_list && this.checkin.price_list.videos_only_sale
    },
    hasCustomVideo() {
      return !!this.customVideoStatus
    },
    customVideoWaitingMessage() {
      const date = this.$options.filters.formatDate(this.customVideoAvlFrom)
      return this.$tc('pages.custom_video.message_waiting', date, {date: date})
    },
    isPromo() {
      return this.checkin.is_promocode || this.checkin.pica_service.is_promo
    },

    getPriceForAllPhotos() {
      if (this.isPromo) {
        return (0).toLocaleString(this.locale, {
          style: 'currency',
          currency: this.checkin.pica_service.currency,
          currencyDisplay: 'symbol',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        })
      }
      // this.checkin.price_list will be null when the event is promo
      const item = this.checkin.price_list.items.find(item => item.quantity === -1)
      return item.price_formatted
    }
  },

  mounted() {
    this.loadMedias()
  },

  methods: {
    selectVideo(video) {
      console.log('selectVideo', video)
      if (this.currentTab === BUYABLE && !video.is_free && !video.media_preview_url) {
        if (this.videoOnlySale) {
          this.$bvToast.toast(this.$t('pages.checkins_detail.video_only_section_selling_info_toast'))
        } else {
          this.$bvToast.toast(this.$t('pages.checkins_detail.video_section_selling_info_toast'))
        }
      } else {
        this.selectedVideo = video
        this.$bvModal.show('modal-video-player')
      }
    },
    async loadMedias() {
      if (this.checkin.has_buyable_photos) {
        EventService.getMediasFromUrl(this.checkin.buyable_photos_url)
            .then(response => {
              this.buyablePhotos = response.data.results
            }).finally(() => this.loadingBuyable = false)
      }
      if (this.checkin.has_bought_photos) {
        EventService.getMediasFromUrl(this.checkin.bought_photos_url)
            .then(response => {
              this.boughtPhotos = response.data.results
            }).finally(() => this.loadingBought = false)
      }

      if (this.checkin.has_buyable_videos) {
        EventService.getMediasFromUrl(this.checkin.buyable_videos_url)
            .then(response => {
              this.buyableVideos = response.data.results
            }).finally(() => this.loadingBuyableVideo = false)
      }
      if (this.checkin.has_bought_videos) {
        EventService.getMediasFromUrl(this.checkin.bought_videos_url)
            .then(response => {
              this.boughtVideos = response.data.results
            }).finally(() => this.loadingBoughtVideo = false)
      }
    },
    onMediaRemoved(mediaId) {
      this.$bvToast.toast(this.$tc('notifications.photo_removed_from_checkin'))
      this.boughtPhotos = this.boughtPhotos.filter(x => x.id !== mediaId)
    }
  }
}
</script>
